import useQueryParams from '../../../../../hooks/useQueryParams';
import useUserProfileQuery from '../../../../../hooks/useUserProfileQuery';
import { InstructorProfile } from './InstructorProfile/InstructorProfile';
import { StudentProfile } from './StudentProfile';

export function UserProfile() {
  const { id } = useQueryParams();
  const { data: profile } = useUserProfileQuery({ id: Number(id) });

  if (!profile) {
    return null;
  }

  const isInstructor = profile.isInstructor;

  return isInstructor ? <InstructorProfile /> : <StudentProfile />;
}
